(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["footer"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on the FAQ page
    if (window.location.pathname === '/pages/faq') {
        // Select the footer element
        var footer = document.querySelector('.m-footer');
        
        // Ensure the element exists before trying to change it
        if (footer) {
            // Function to change the background image based on screen size
            function updateFooterImage() {
                if (window.matchMedia("(max-width: 767px)").matches) {
                    // For screens 767px or less
                    footer.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0635/6772/4787/files/faqwavy.png?v=1728723255')";
                } else {
                    // For screens larger than 767px
                    footer.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0635/6772/4787/files/elzaMask-group.png?v=1727946145')";
                }
            }
            
            // Run the function on page load
            updateFooterImage();
            
            // Update the image if the screen is resized
            window.addEventListener('resize', updateFooterImage);
        }
    }
});



  
  } catch(e) { console.error(e); }
})();
      })();
